module.exports = __webpack_public_path__ + "static/img/200336.893e8564.png";